/**
 * Created by lihanying on 2017/10/18.
 */

import React from 'react'
import { DatePicker, Button, Spin, Table, message } from 'antd'
import moment from 'moment'
import SnDetail from './snDetail'

export default class extends React.Component {
  state = {
    year_month: new Date().toISOString().slice(0, 10), //默认今天
    loading: true,
    loading1: false,
    visible: false,
  }
  componentDidMount() {
    const data = {
      sum_date: this.state.year_month,
      table_id: this.props.record.table_id,
    }
    this.props.fetchClubSettlement(data).then((res) => {
      this.setState({ loading: false, loading1: false })
    })
  }

  onChange = (value, dateString) => {
    this.setState({ year_month: dateString })
  }

  onSubmit = () => {
    const { year_month } = this.state
    if (year_month.length > 0) {
      let data = {
        sum_date: year_month,
        table_id: this.props.record.table_id,
      }
      this.setState({ loading: true, loading1: false, visible: false }, () => {
        this.props.fetchClubSettlement(data).then((res) => {
          {
            this.setState({ loading: false })
          }
        }) //分日分账
      })
    } else {
      message.info('请输入时间搜索')
    }
  }

  render() {
    const { billRecord, billRecordDetail } = this.props
    const columns = [
      {
        title: '时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '订单号',
        dataIndex: 'temporary_number',
        key: 'temporary_number',
      },
      {
        title: '流水号',
        dataIndex: 'serial_number',
        key: 'serial_number',
      },
      {
        title: '支付属性',
        dataIndex: 'check_out_types',
        key: 'check_out_types',
      },
      {
        title: '支付方式',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '实收金额',
        dataIndex: 'paid_in',
        key: 'paid_in',
      },
      {
        title: '免收',
        dataIndex: 'change',
        key: 'change',
        className: 'change_red',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <Button
              type="link"
              onClick={() => {
                this.setState({ loading1: true, visible: true })
                this.props
                  .fetchBillRecordDetail(record.serial_number)
                  .then((res) => {
                    this.setState({ loading1: false })
                  })
              }}
            >
              详情
            </Button>
          )
        },
      },
    ]

    const data =
      billRecord.data &&
      billRecord.data.map((item) => {
        if (item.check_out_type === '1') {
          item.check_out_types = '个人'
        } else if (item.check_out_type === '2') {
          item.check_out_types = '整体'
        } else {
          item.check_out_types = '单条'
        }
        return item
      })

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <DatePicker
            size="large"
            defaultValue={moment(`${this.state.year_month}`, 'YYYY-MM-DD')}
            onChange={(value, dateString) => this.onChange(value, dateString)}
          />
          <Button type="primary" onClick={() => this.onSubmit()}>
            查询
          </Button>
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={data}
            size="small"
          />
        )}

        {this.state.loading1 ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <div>
            {this.state.visible && <SnDetail list={billRecordDetail} />}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/component/record.js